<template>
  <DeepAppIcon
    v-if="currentBoxDeepAppIcon"
    :height="size"
    :logo="currentBoxDeepAppIcon"
    :width="size"
  />
  <DeepIcon v-else :height="size" name="box" :width="size" />
</template>

<script setup lang="ts">
import { DeepAppIcon, DeepIcon } from '@deepcloud/deep-ui-lib'
import type { BoxEntry } from '@deepcloud/api-deep-box'

const props = defineProps({
  box: {
    type: Object as PropType<BoxEntry>,
    default: undefined,
  },
  size: {
    type: Number,
    default: 16,
  },
})

const isBoxTypePortal = computed(() => props.box?.boxType === 'portal')
const isBoxTypeDeepNinja = computed(() => props.box?.boxType === 'deep-ninja')
const isBoxTypeHoop = computed(() => props.box?.boxType === 'hoop')

const currentBoxDeepAppIcon = computed(() => {
  if (isBoxTypePortal.value) return 'deepportal'
  if (isBoxTypeDeepNinja.value) return 'deepninja'
  if (isBoxTypeHoop.value) return 'hoop'
  return undefined
})
</script>
